// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/upgrade_butn_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/upgrade_butn_hover.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBar_container__DruKw {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* width: 100%; */
    width: 280px;
    height: 100%;
    background-color: #000;
    /* padding: 13px 17px; */
    padding: 13px 0px;
}

.SideBar_userinfo_box__9AUaG {
    width: 100%;
    height: 40px;
    padding: 0 17px;
}

.SideBar_divider_box__hkCGz {
    width: 100%;
    padding: 0 17px;
}

.SideBar_newchat_box__6UFx1 {
    width: 100%;
    /* height: calc(100% - 142px); */
    height: calc(100% - 40px - 23px - 79px);
}

.SideBar_upgrade_butn_container__nCY9n {
    width: 100%;
    padding: 0 17px;
}

.SideBar_upgrade_butn_box__c2GDG {
    width: 100%;
    height: 61px;
    margin-top: 18px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    transition: background-image 0.5s;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.SideBar_upgrade_butn_box__c2GDG::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.SideBar_upgrade_butn_box__c2GDG:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.SideBar_upgrade_butn__flglp {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 61px;
    padding-top: 5px;
    border-radius: 6px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    /* background-image: linear-gradient(to top right, #004e58 7%, #0a9ba8 54%, #2ec0ff 100%); */
}

/* .upgrade_butn_box:hover .upgrade_butn {
    background-image: linear-gradient(to top right, #138292 7%, #09bbcb 54%, #05b2fc 100%);
} */

.SideBar_upgrade_img_box__mOIxi {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -18px;
    left: calc(50% - 20px);
    width: 37px;
    height: 37px;
    background-color: #000;
    border-radius: 50%;
}

.SideBar_upgrade_img__fOqkd {
    width: 37px;
    height: 37px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBar/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gFAAuF;IACvF,iCAAiC;AACrC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA0F;IAC1F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA0F;AAC9F;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,4FAA4F;AAChG;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    /* width: 100%; */\n    width: 280px;\n    height: 100%;\n    background-color: #000;\n    /* padding: 13px 17px; */\n    padding: 13px 0px;\n}\n\n.userinfo_box {\n    width: 100%;\n    height: 40px;\n    padding: 0 17px;\n}\n\n.divider_box {\n    width: 100%;\n    padding: 0 17px;\n}\n\n.newchat_box {\n    width: 100%;\n    /* height: calc(100% - 142px); */\n    height: calc(100% - 40px - 23px - 79px);\n}\n\n.upgrade_butn_container {\n    width: 100%;\n    padding: 0 17px;\n}\n\n.upgrade_butn_box {\n    width: 100%;\n    height: 61px;\n    margin-top: 18px;\n    background: url('../../../../statics/upgrade_butn_bg.png') no-repeat center / 100% 100%;\n    transition: background-image 0.5s;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.upgrade_butn_box::after {\n    content: \"\";\n    background: url('../../../../statics/upgrade_butn_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.upgrade_butn_box:hover {\n    background: url('../../../../statics/upgrade_butn_hover.png') no-repeat center / 100% 100%;\n}\n\n.upgrade_butn {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 61px;\n    padding-top: 5px;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #fff;\n    cursor: pointer;\n    /* background-image: linear-gradient(to top right, #004e58 7%, #0a9ba8 54%, #2ec0ff 100%); */\n}\n\n/* .upgrade_butn_box:hover .upgrade_butn {\n    background-image: linear-gradient(to top right, #138292 7%, #09bbcb 54%, #05b2fc 100%);\n} */\n\n.upgrade_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: -18px;\n    left: calc(50% - 20px);\n    width: 37px;\n    height: 37px;\n    background-color: #000;\n    border-radius: 50%;\n}\n\n.upgrade_img {\n    width: 37px;\n    height: 37px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideBar_container__DruKw`,
	"userinfo_box": `SideBar_userinfo_box__9AUaG`,
	"divider_box": `SideBar_divider_box__hkCGz`,
	"newchat_box": `SideBar_newchat_box__6UFx1`,
	"upgrade_butn_container": `SideBar_upgrade_butn_container__nCY9n`,
	"upgrade_butn_box": `SideBar_upgrade_butn_box__c2GDG`,
	"upgrade_butn": `SideBar_upgrade_butn__flglp`,
	"upgrade_img_box": `SideBar_upgrade_img_box__mOIxi`,
	"upgrade_img": `SideBar_upgrade_img__fOqkd`
};
export default ___CSS_LOADER_EXPORT___;
